// extracted by mini-css-extract-plugin
export default {"lawPartners":"styles_lawPartners__wfykn","fourPoints":"styles_fourPoints__OmWzH"};